import { render, staticRenderFns } from "./BicInputField.vue?vue&type=template&id=d9c3b838&scoped=true"
import script from "./BicInputField.vue?vue&type=script&lang=ts"
export * from "./BicInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c3b838",
  null
  
)

export default component.exports